import CheckboxComponent from "@/components/Checkbox";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Checkbox = CheckboxComponent as any;
import { useAppDispatch } from "@/lib/redux/hooks";
import {
  ProductFilterOption,
  updateProductFilterOption,
} from "@/lib/redux/productFilters/productFiltersSlice";
import { useCallback } from "react";
import { productFilterValueToLabel } from "@/lib/helpers";

type Props = {
  filterId: string;
  option: ProductFilterOption;
};

const Item: React.FC<Props> = (props) => {
  const { filterId, option } = props;
  const { value, selected, count } = option;
  const dispatch = useAppDispatch();

  let label = productFilterValueToLabel(value);
  if (count != null) {
    label += " (" + count + ")";
  }

  const handleChange = useCallback(() => {
    dispatch(
      updateProductFilterOption({
        filterId: filterId,
        optionId: value,
        changes: {
          // Toggle selected option
          selected: !selected,
        },
      })
    );
  }, [dispatch, filterId, value, selected]);

  return (
    <Checkbox
      key={value}
      value={value}
      checked={selected}
      onChange={handleChange}
      disabled={count === 0}
    >
      {label}
    </Checkbox>
  );
};

export default Item;
